"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCamel = void 0;
exports.toCamel = function (o) {
    var newO = null;
    var origKey = null;
    var newKey = null;
    var value = null;
    if (o instanceof Array) {
        return o.map(function (value) {
            var newValue = value;
            if (typeof value === 'object') {
                newValue = exports.toCamel(value);
            }
            return newValue;
        });
    }
    newO = {};
    for (origKey in o) {
        if (o.hasOwnProperty(origKey)) {
            newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
            value = o[origKey];
            if (value instanceof Array || (value !== null && value.constructor === Object)) {
                value = exports.toCamel(value);
            }
            newO[newKey] = value;
        }
    }
    return newO;
};
